window.global ||=  window;

